import request from 'utils/request';

export function createSurveyModel(params, options) {
  const requestOptions = {
    ...options,
    method: 'PUT',
    queryParams: params,
  };
  return request('/api/v1/survey', requestOptions);
}

export function createThirdPartySurveyModel(params, options) {
  const requestOptions = {
    ...options,
    method: 'POST',
    queryParams: params,
  };
  return request('/api/v3/third-party-survey', requestOptions);
}

export function createDistributedSurveyModel(params, options) {
  const requestOptions = {
    ...options,
    method: 'POST',
    queryParams: params,
  };
  return request('/api/v3/distribution-link', requestOptions);
}

export function createPeeqSurveyModel(params, options) {
  const requestOptions = {
    ...options,
    method: 'POST',
    queryParams: params,
  };
  return request('/api/v3/survey/peeq', requestOptions);
}

export function fetchPeeqCountryOptions(params, options) {
  const requestOptions = {
    ...options,
    method: 'GET',
    queryParams: params,
  };
  return request('/api/v3/survey/peeq/supported-countries', requestOptions);
}
